(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => {
        if (searchModal.querySelector('details[open]')) searchModal.close(false);
      });
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function spaceProductLinks() {
    document.querySelectorAll('.nex3d-product-links').forEach((row) => {
      if (row.dataset.spacingReady) return;
      const first = row.querySelector('.nex3d-purchase-confidence__details > summary');
      const last = row.querySelector('share-button .share-button__button');
      if (!first || !last) return;
      row.dataset.spacingReady = 'true';
      const update = () => {
        const offset = (first.getBoundingClientRect().width - last.getBoundingClientRect().width) / 2;
        row.style.setProperty('--nex3d-middle-offset', `${offset}px`);
      };
      const observer = new ResizeObserver(update);
      observer.observe(first);
      observer.observe(last);
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', spaceProductLinks, { once: true });
  } else {
    spaceProductLinks();
  }
  document.addEventListener('shopify:section:load', spaceProductLinks);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nex3d-category-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nex3d-category-carousel')) {
    customElements.define('nex3d-category-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-category-track]');
        this.cards = [...this.querySelectorAll('.nex3d-category-card')];
        this.controls = this.querySelector('[data-category-controls]');
        if (!this.track || !this.controls || this.cards.length < 2) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.previous = this.querySelector('[data-category-previous]');
        this.next = this.querySelector('[data-category-next]');
        this.position = this.querySelector('[data-category-position]');
        this.mobile = matchMedia('(max-width: 749px)');
        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.track.addEventListener('scroll', () => {
          this.queueUpdate();
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => { this.targetIndex = null; }, 150);
        }, { passive: true, signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !this.mobile.matches) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          const step = event.key === 'ArrowRight' ? (rtl ? -1 : 1) : event.key === 'ArrowLeft' ? (rtl ? 1 : -1) : 0;
          if (step) { event.preventDefault(); this.move(step); }
          else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.goTo(event.key === 'Home' ? 0 : this.cards.length - 1);
          }
        }, { signal });
        this.mobile.addEventListener('change', () => this.queueUpdate(), { signal });
        this.observer?.disconnect();
        this.observer = new ResizeObserver(() => this.queueUpdate());
        this.observer.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        clearTimeout(this.scrollTimer);
        this.targetIndex = null;
      }

      queueUpdate() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }

      update() {
        const enabled = this.mobile.matches && this.track.scrollWidth > this.track.clientWidth + 1;
        this.controls.hidden = !enabled;
        if (!enabled) {
          this.track.removeAttribute('tabindex');
          this.targetIndex = null;
          return;
        }
        this.track.setAttribute('tabindex', '0');
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const trackRect = this.track.getBoundingClientRect();
        const edge = rtl ? trackRect.right : trackRect.left;
        let distance = Infinity;
        this.index = 0;
        this.cards.forEach((card, index) => {
          const rect = card.getBoundingClientRect();
          const gap = Math.abs((rtl ? rect.right : rect.left) - edge);
          if (gap < distance) { distance = gap; this.index = index; }
        });
        this.previous.setAttribute('aria-disabled', String(this.index === 0));
        this.next.setAttribute('aria-disabled', String(this.index === this.cards.length - 1));
        const label = this.position.dataset.positionTemplate.replace('[current]', this.index + 1).replace('[total]', this.cards.length);
        if (this.position.textContent.trim() !== label) this.position.textContent = label;
      }

      move(step) {
        this.goTo((this.targetIndex ?? this.index ?? 0) + step);
      }

      goTo(index) {
        if (!this.mobile.matches || this.controls.hidden) return;
        this.targetIndex = Math.max(0, Math.min(index, this.cards.length - 1));
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const trackRect = this.track.getBoundingClientRect();
        const cardRect = this.cards[this.targetIndex].getBoundingClientRect();
        const left = rtl ? cardRect.right - trackRect.right : cardRect.left - trackRect.left;
        this.track.scrollBy({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nex3d-printer-quiz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nex3d-printer-quiz')) {
    customElements.define(
      'nex3d-printer-quiz',
      class Nex3dPrinterQuiz extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.intro = this.querySelector('[data-quiz-intro]');
          this.form = this.querySelector('[data-quiz-form]');
          this.allSteps = Array.from(this.querySelectorAll('[data-quiz-step]'));
          this.steps = [...this.allSteps];
          this.results = this.querySelector('[data-quiz-results]');
          this.resultGrid = this.querySelector('[data-result-grid]');
          this.candidates = Array.from(this.querySelectorAll('[data-candidate]'));
          this.specialistResult = this.querySelector('[data-specialist-result]');
          this.progress = this.querySelector('[data-quiz-progress]');
          this.progressCurrent = this.querySelector('[data-progress-current]');
          this.progressTotal = this.querySelector('[data-progress-total]');
          this.progressFallbackCurrent = this.querySelector('[data-progress-fallback-current]');
          this.progressFallbackTotal = this.querySelector('[data-progress-fallback-total]');
          this.backButton = this.querySelector('[data-quiz-back]');
          this.nextButton = this.querySelector('[data-quiz-next]');
          this.nextLabel = this.querySelector('[data-next-label]');
          this.currentStep = 0;
          this.nextText = this.nextLabel.textContent;
          this.colourWasRouteDefault = false;
          this.transitioning = false;

          this.querySelector('[data-quiz-start]').addEventListener('click', () => this.start());
          this.querySelector('[data-quiz-restart]').addEventListener('click', () => this.restart());
          this.backButton.addEventListener('click', () => this.back());
          this.nextButton.addEventListener('click', () => this.next());
          this.form.addEventListener('submit', (event) => event.preventDefault());
          this.form.addEventListener('change', (event) => {
            if (event.target.name === 'workflow') this.syncRoute();
            this.updateNavigation();
          });
          this.progress.max = this.steps.length;
          this.progressTotal.textContent = this.steps.length;
          this.progressFallbackTotal.textContent = this.steps.length;
        }

        transition(update) {
          if (this.transitioning) return false;
          this.transitioning = true;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const release = () => {
            this.transitioning = false;
          };
          if (document.startViewTransition && !reduceMotion) {
            document.startViewTransition(update).finished.finally(release);
          } else {
            update();
            requestAnimationFrame(release);
          }
          return true;
        }

        focusAndScroll(target) {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.focus({ preventScroll: true });
          target.scrollIntoView({
            behavior: reduceMotion ? 'auto' : 'smooth',
            block: 'start',
          });
        }

        syncRoute() {
          const workflow = this.form.querySelector('[name="workflow"]:checked')?.value;
          const skipColour = workflow === 'resin' || workflow === 'sls';
          const colourAny = this.form.querySelector('[name="colour"][value="any"]');

          if (skipColour) {
            colourAny.checked = true;
            this.colourWasRouteDefault = true;
          } else if (this.colourWasRouteDefault) {
            colourAny.checked = false;
            this.colourWasRouteDefault = false;
          }

          this.steps = this.allSteps.filter((step) => !(skipColour && step.dataset.question === 'colour'));
          this.currentStep = Math.min(this.currentStep, this.steps.length - 1);
          this.progress.max = this.steps.length;
          this.progressTotal.textContent = this.steps.length;
          this.progressFallbackTotal.textContent = this.steps.length;
        }

        start() {
          if (this.transitioning) return;
          this.form.reset();
          this.colourWasRouteDefault = false;
          this.transition(() => {
            this.intro.hidden = true;
            this.results.hidden = true;
            this.form.hidden = false;
            this.currentStep = 0;
            this.syncRoute();
            this.showStep();
          });
        }

        restart() {
          if (this.transitioning) return;
          this.form.reset();
          this.colourWasRouteDefault = false;
          this.candidates.forEach((candidate) => {
            candidate.hidden = true;
          });
          this.specialistResult.hidden = true;
          this.transition(() => {
            this.results.hidden = true;
            this.form.hidden = false;
            this.currentStep = 0;
            this.syncRoute();
            this.showStep();
          });
        }

        showStep() {
          this.syncRoute();
          const current = this.steps[this.currentStep];
          this.allSteps.forEach((step) => {
            step.hidden = step !== current;
          });
          this.progress.value = this.currentStep + 1;
          this.progressCurrent.textContent = this.currentStep + 1;
          this.progressFallbackCurrent.textContent = this.currentStep + 1;
          this.updateNavigation();
          requestAnimationFrame(() => this.focusAndScroll(current.querySelector('legend')));
        }

        updateNavigation() {
          const selected = this.steps[this.currentStep].querySelector('input:checked');
          this.nextButton.disabled = !selected;
          this.backButton.hidden = this.currentStep === 0;
          this.nextLabel.textContent = this.currentStep === this.steps.length - 1 ? this.dataset.viewLabel : this.nextText;
        }

        next() {
          if (this.transitioning) return;
          if (!this.steps[this.currentStep].querySelector('input:checked')) return;
          if (this.currentStep === this.steps.length - 1) {
            this.showResults();
            return;
          }
          this.transition(() => {
            this.currentStep += 1;
            this.showStep();
          });
        }

        back() {
          if (this.transitioning) return;
          if (this.currentStep === 0) return;
          this.transition(() => {
            this.currentStep -= 1;
            this.showStep();
          });
        }

        values(candidate, name) {
          return (candidate.dataset[name] || '')
            .split(',')
            .map((value) => value.trim())
            .filter(Boolean);
        }

        configuration(candidate, answers) {
          let type = 'base';
          if (answers.colour === 'automatic') {
            type =
              answers.workflow === 'engineering' && candidate.dataset.automaticEngineeringVariantId
                ? 'automaticEngineering'
                : 'automatic';
          } else if (answers.colour === 'independent') {
            type = 'independent';
          } else if (answers.workflow === 'engineering' && candidate.dataset.engineeringVariantId) {
            type = 'engineering';
          }

          const variantId = candidate.dataset[`${type}VariantId`] || '';
          const available = Boolean(variantId) && candidate.dataset[`${type}Available`] === 'true';
          const quoteOnly = candidate.dataset.quoteOnly === 'true';
          return {
            type,
            variantId,
            price: Number(candidate.dataset[`${type}Price`]) || 0,
            available,
            quoteOnly,
            orderable: Boolean(variantId) && (available || quoteOnly),
            url: candidate.dataset[`${type}Url`] || '',
            title: candidate.dataset[`${type}Title`] || '',
            configured: type !== 'base',
          };
        }

        effectivePrice(candidate, answers) {
          return this.configuration(candidate, answers).price;
        }

        withinBudget(price, budget) {
          if (budget === 'under_500') return price < 50000;
          if (budget === '500_1199') return price < 120000;
          if (budget === '1200_2499') return price < 250000;
          return true;
        }

        budgetScore(price, budget) {
          if (budget === 'flexible') return 1;
          if (budget === 'under_500') return price < 50000 ? 7 : 0;
          if (budget === '500_1199') return price >= 50000 && price < 120000 ? 7 : 3;
          if (budget === '1200_2499') return price >= 120000 && price < 250000 ? 7 : 2;
          if (budget === '2500_plus') return price >= 250000 ? 7 : 2;
          return 0;
        }

        score(candidate, answers) {
          let score = 0;
          if (this.values(candidate, 'applications').includes(answers.application)) score += 8;
          if (answers.workflow === 'any' || this.values(candidate, 'workflows').includes(answers.workflow)) score += 10;
          if (answers.size === 'any') score += 1;
          else if (this.values(candidate, 'sizes').includes(answers.size)) score += 5;
          if (answers.colour === 'any') score += 1;
          else if (answers.colour === 'single') score += 2;
          else if (this.values(candidate, 'colours').includes(answers.colour)) score += 6;
          if (answers.setup === 'any') score += 1;
          else if (this.values(candidate, 'setups').includes(answers.setup)) score += 4;
          score += this.budgetScore(this.effectivePrice(candidate, answers), answers.budget);
          return score;
        }

        exactMatches(candidate, answers) {
          let matches = 1;
          if (answers.workflow !== 'any' && this.values(candidate, 'workflows').includes(answers.workflow)) matches += 1;
          if (answers.size !== 'any' && this.values(candidate, 'sizes').includes(answers.size)) matches += 1;
          if (
            answers.colour !== 'any' &&
            answers.colour !== 'single' &&
            this.values(candidate, 'colours').includes(answers.colour)
          ) {
            matches += 1;
          }
          if (answers.setup !== 'any' && this.values(candidate, 'setups').includes(answers.setup)) matches += 1;
          return matches;
        }

        formatPrice(price) {
          const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
            style: 'currency',
            currency: this.dataset.currency || 'CAD',
            currencyDisplay: 'narrowSymbol',
          }).format(price / 100);
          return `${amount} ${this.dataset.currency || 'CAD'}`;
        }

        updateCandidate(candidate, configuration) {
          candidate.querySelector('[data-result-price-prefix]').textContent = configuration.quoteOnly
            ? this.dataset.referencePriceLabel
            : configuration.configured
              ? this.dataset.configuredPriceLabel
              : this.dataset.startingPriceLabel;
          candidate.querySelector('[data-result-price]').textContent = this.formatPrice(configuration.price);
          candidate.querySelectorAll('[data-result-link]').forEach((link) => {
            link.href = configuration.url;
          });

          const configurationRow = candidate.querySelector('[data-result-configuration]');
          const showConfiguration = configuration.title && configuration.title !== 'Default Title';
          configurationRow.hidden = !showConfiguration;
          configurationRow.querySelector('[data-result-configuration-value]').textContent = configuration.title;

          candidate.dataset.selectedAvailable = configuration.available;
          candidate.dataset.selectedQuote = configuration.quoteOnly;
          candidate.querySelector('[data-result-availability-label]').textContent = configuration.quoteOnly
            ? this.dataset.quoteLabel
            : configuration.available
              ? this.dataset.availableLabel
              : this.dataset.unavailableLabel;
          candidate.querySelector('[data-result-button]').textContent = configuration.quoteOnly
            ? this.dataset.requestQuoteLabel
            : this.dataset.viewConfigurationLabel;
        }

        selectBalancedMatches(ranked) {
          if (ranked.length < 2) return ranked.slice(0, 3);
          const selected = [ranked[0]];
          const differentVendor = ranked
            .slice(1)
            .find(
              (match) =>
                match.candidate.dataset.vendor !== ranked[0].candidate.dataset.vendor &&
                ranked[0].score - match.score <= 4
            );
          if (differentVendor) selected.push(differentVendor);
          ranked.forEach((match) => {
            if (selected.length < 3 && !selected.includes(match)) selected.push(match);
          });
          return selected;
        }

        showResults() {
          const answers = Object.fromEntries(new FormData(this.form).entries());
          this.candidates.forEach((candidate) => {
            candidate.hidden = true;
            candidate.classList.remove('is-best-match');
            delete candidate.dataset.selectedAvailable;
            delete candidate.dataset.selectedQuote;
          });
          this.specialistResult.hidden = true;

          const ranked = this.candidates
            .filter((candidate) => {
              const configuration = this.configuration(candidate, answers);
              const applicationMatch = this.values(candidate, 'applications').includes(answers.application);
              const workflowMatch =
                answers.workflow === 'any' || this.values(candidate, 'workflows').includes(answers.workflow);
              const sizeMatch = answers.size === 'any' || this.values(candidate, 'sizes').includes(answers.size);
              const colourMatch =
                answers.colour === 'any' ||
                answers.colour === 'single' ||
                this.values(candidate, 'colours').includes(answers.colour);
              const setupMatch = answers.setup === 'any' || this.values(candidate, 'setups').includes(answers.setup);
              return (
                configuration.orderable &&
                applicationMatch &&
                workflowMatch &&
                sizeMatch &&
                colourMatch &&
                setupMatch &&
                this.withinBudget(this.effectivePrice(candidate, answers), answers.budget)
              );
            })
            .map((candidate) => ({
              candidate,
              configuration: this.configuration(candidate, answers),
              price: this.effectivePrice(candidate, answers),
              score: this.score(candidate, answers),
              exact: this.exactMatches(candidate, answers),
            }))
            .sort(
              (a, b) =>
                b.score - a.score ||
                b.exact - a.exact ||
                a.price - b.price ||
                a.candidate.querySelector('h3').textContent.localeCompare(b.candidate.querySelector('h3').textContent)
            );

          const matches = this.selectBalancedMatches(ranked);

          matches.forEach((match, index) => {
            this.resultGrid.append(match.candidate);
            match.candidate.hidden = false;
            match.candidate.classList.toggle('is-best-match', index === 0);
            this.updateCandidate(match.candidate, match.configuration);
            match.candidate.querySelector('[data-result-rank]').textContent =
              index === 0 ? this.dataset.bestLabel : this.dataset.alternativeLabel;
          });

          if (matches.length === 0) this.specialistResult.hidden = false;

          const status = this.querySelector('[data-results-status]');
          this.transition(() => {
            this.form.hidden = true;
            this.results.hidden = false;
            status.textContent =
              matches.length === 0
                ? this.dataset.specialistStatus
                : `${matches.length} ${matches.length === 1 ? this.dataset.readySingular : this.dataset.readyPlural}`;
            requestAnimationFrame(() => {
              this.focusAndScroll(this.querySelector('[data-results-heading]'));
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
